import { GalaxyConfig, StarData, StarPosition, ViewMode } from 'types/galaxy';

import { calculateClustersPositions } from './clusters';
import { calculateDnaPositions } from './dna';
import { calculateGridPositions } from './grid';
import { calculateHelixPositions } from './helix';
import { calculateMindPositions } from './mind';
import { calculateScatterPositions } from './scatter';
import { calculateSpherePositions } from './sphere';
import { calculateSpiralPositions } from './spiral';
import { calculateSpringPositions } from './spring';
import { calculateSunflowerPositions } from './sunflower';
import { calculateTiersPositions } from './tiers';
import { calculateTornadoPositions } from './tornado';

export type ViewModeCalculatorFn = (starsData: StarData[], config: GalaxyConfig) => StarPosition[];

export const VIEW_MODE_CALCULATORS: Record<ViewMode, ViewModeCalculatorFn> = {
  spiral: calculateSpiralPositions,
  tiers: calculateTiersPositions,
  scatter: calculateScatterPositions,
  helix: calculateHelixPositions,
  sphere: calculateSpherePositions,
  tornado: calculateTornadoPositions,
  grid: calculateGridPositions,
  sunflower: calculateSunflowerPositions,
  dna: calculateDnaPositions,
  spring: calculateSpringPositions,
  clusters: calculateClustersPositions,
  mind: calculateMindPositions,
};
